import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  // Auto-redirect after 10 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/', { replace: true });
    }, 10000);
    
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 px-4">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-md w-full p-8 bg-white rounded-xl shadow-xl text-center animate-fade-in"
      >
        <motion.h1 
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          transition={{ 
            type: "spring",
            stiffness: 300,
            damping: 15,
            delay: 0.2
          }}
          className="text-7xl font-bold text-primary mb-4"
        >
          404
        </motion.h1>
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">Page Not Found</h2>
        <p className="text-gray-600 mb-8">
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </p>
        <div className="space-y-3">
          <Link
            to="/"
            className="block w-full px-6 py-3 bg-primary text-white font-medium rounded-md hover:bg-primary/90 transition-colors"
          >
            Go Back Home
          </Link>
          <button
            onClick={() => navigate(-1)}
            className="block w-full px-6 py-3 bg-gray-200 text-gray-800 font-medium rounded-md hover:bg-gray-300 transition-colors"
          >
            Go Back
          </button>
          <Link
            to="/diagnostic"
            className="block w-full px-6 py-3 bg-blue-100 text-blue-800 font-medium rounded-md hover:bg-blue-200 transition-colors"
          >
            View Diagnostic Page
          </Link>
        </div>
        <p className="mt-8 text-sm text-gray-500">
          You will be automatically redirected to the home page in a few seconds...
        </p>
      </motion.div>
    </div>
  );
};

export default NotFound; 